import { Accordion } from 'react-bootstrap'
import {
  BadgeSuccessSVG,
  BadgeWarningSVG,
  CheckSVG,
  ErrorSVG,
  XSVG,
} from 'src/components/Icons/Basic'
import palette from 'src/designSystem/variables/palette'
import styled, { keyframes } from 'styled-components/macro'

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`

// Wraps the citations of a live-finishing procedure so they fade in once the
// typed reasoning completes (matches TI's reveal feel).
export const FadeIn = styled.div`
  animation: ${fadeIn} 0.4s ease;
`

export const AuditScanControlsAccordion = styled(Accordion)`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-top: 8px;
  > .accordion-item,
  > .accordion-item:not(:first-of-type) {
    border-radius: 14px;
    border: 1px solid ${palette.neutral[100]};
  }
  > .accordion-body {
    overflow-y: auto;
    height: 100%;
  }
  height: 100%;
  width: 100%;
  flex: 1;
`

export const AuditScanControlTestAccordion = styled(Accordion)`
  padding-top: 4px;
  padding-bottom: 4px;
`

export const AuditScanControlPassIcon = styled(BadgeSuccessSVG)`
  min-height: 16px;
  min-width: 16px;
  max-height: 16px;
  max-width: 16px;
`

export const AuditScanControlFailIcon = styled(ErrorSVG)`
  height: 18px;
  width: 18px;
  position: relative;
  left: -1px;
  path {
    fill: ${palette.magenta[500]};
  }
`

export const AuditScanControlIncompleteIcon = styled(BadgeWarningSVG)`
  height: 18px;
  width: 18px;
  position: relative;
  left: -1px;
  path {
    fill: ${palette.orange[600]};
  }
`

export const AuditScanControlNotScannedIcon = styled(ErrorSVG)`
  height: 18px;
  width: 18px;
  path {
    fill: ${palette.neutral[500]};
  }
`

export const AuditScanControlTestPassIcon = styled(CheckSVG)`
  width: 16px;
  height: 16px;
`

export const AuditScanControlTestFailIcon = styled(XSVG)`
  height: 12px;
  padding-bottom: 1px;
  width: 16px;
  align-items: center;
  justify-content: center;
  path {
    fill: ${palette.magenta[500]};
  }
`

export const AuditScanControlTestUnknownXIcon = styled(XSVG)`
  height: 12px;
  padding-bottom: 1px;
  width: 16px;
  align-items: center;
  justify-content: center;
  path {
    fill: ${palette.orange[600]};
  }
`

export const AuditScanControlTestNAIcon = styled(CheckSVG)`
  height: 12px;
  padding-bottom: 1px;
  width: 16px;
  align-items: center;
  justify-content: center;
  path {
    fill: ${palette.neutral[300]};
  }
`
